import EventTypes from "@wesstron/utils/Api/constants/eventTypes";
import {lowerFirst, memoize, uniq} from "lodash";
import moment from "moment";
import {USG_STATE} from "../constans/eventTypes";
import {GraftingProgramApplicationTypes} from "../constans/graftingProgramApplicationTypes";
import i18n from "../i18n";
import store from "../store/store";
import {preEvents} from "./AnimalDocumentsUtils";
import {
    getFirstCycleIndex,
    getTimeFromInseminationToPartuition,
    getTimeFromInseminationToPregnancy,
    getTimeOnMatingRoom,
    getTimeOnSowsRoom,
} from "./SettingsUtils";
import {createKeyToValueDictionary} from "./Utils";

export const REMOVE_TECHNOLOGY_GROUP_REASONS = {
    INSEMINATION_OTHER_WEEK: 0,
    NEGATIVE_USG: 1,
    NO_PREGNANCY: 2,
    SEPARATION: 3,
    FALL: 4,
    SELL: 5,
    NEXT_CYCLE: 6,
    NO_PARTURITION_EVENT: 7,
    IS_MOMMY: 8,
    REMOVED_ALL_PIGLETS: 9,
};

export const ANIMALS_IN_GROUP = `SELECT LIST(DISTINCT AnmID) as AnmIDs FROM (SELECT AnmID, ANY_VALUE(AnmNo1) as AnmNo1, FIRST(value) FILTER(WHERE key = 'technologyGroupRemoval') as removeReason FROM ParamsTable WHERE group_nr = ? GROUP BY AnmID ORDER BY AnmNo1 ASC) WHERE removeReason IS NULL OR removeReason IN (${REMOVE_TECHNOLOGY_GROUP_REASONS.SEPARATION}::VARCHAR, ${REMOVE_TECHNOLOGY_GROUP_REASONS.REMOVED_ALL_PIGLETS}::VARCHAR)`;

const GROUPS_FOR_ANIMALS =
    "SELECT LAST(group_nr) as group_nr FROM ParamsTable WHERE actCycle = true AND AnmID IN ? GROUP BY AnmID";

export const TECHNOLOGY_GROUP_GRID = `WITH groupInseminationsCte AS (
  SELECT 
    AnmID,
    cycle::INTEGER as cycle,
    group_nr,
    EPOCH_MS(dataEv :: BIGINT) as dataEv 
  FROM 
    ParamsTable 
  WHERE 
    key = 'boar' 
    AND group_nr IN ? 
  ORDER BY 
    dataEv
), 
removedCte AS (
  SELECT 
    group_nr, 
    AnmID, 
    value 
  FROM 
    ParamsTable 
  WHERE 
    key = 'technologyGroupRemoval' 
    AND group_nr IN ? 
    AND value NOT IN (
      ${REMOVE_TECHNOLOGY_GROUP_REASONS.SEPARATION}::VARCHAR, 
      ${REMOVE_TECHNOLOGY_GROUP_REASONS.REMOVED_ALL_PIGLETS}::VARCHAR
    ) 
  ORDER BY 
    dataEv
), 
animalInseminationCte AS (
  SELECT 
    AnmID, 
    FIRST(cycle) as cycle, 
    FIRST(dataEv) as dataEv, 
    FIRST(group_nr) as group_nr 
  FROM 
    groupInseminationsCte 
  GROUP BY 
    group_nr, 
    AnmID
), 
dataCte AS (
  SELECT 
    animalInseminationCte.*, 
    removedCte.value IS NOT NULL as isRemoved 
  FROM 
    animalInseminationCte 
    LEFT JOIN removedCte ON CONCAT(
      animalInseminationCte.AnmID, animalInseminationCte.group_nr
    ) = CONCAT(
      removedCte.AnmID, removedCte.group_nr
    )
) 
SELECT 
  DATE_ADD(
    EPOCH_MS(? :: BIGINT), 
    TO_WEEKS(
      DATE_DIFF(
        'week', 
        EPOCH_MS(? :: BIGINT), 
        FIRST(dataEv)
      )
    )
  ) as week, 
  FIRST(group_nr) as group_nr, 
  COALESCE(LIST(DISTINCT AnmID) FILTER(
    WHERE 
      cycle = ?
  ), []) as firstCycleSows, 
  COALESCE(LIST(DISTINCT AnmID) FILTER(
    WHERE 
      cycle > ?
  ), []) as sows, 
  COALESCE(LIST(DISTINCT AnmID) FILTER(
    WHERE 
      cycle = ? 
      AND isRemoved = true
  ), []) as removedFirstCycleSows, 
  COALESCE(LIST(DISTINCT AnmID) FILTER(
    WHERE 
      cycle > ? 
      AND isRemoved = true
  ), []) as removedSows 
FROM 
  dataCte 
GROUP BY 
  DATE_ADD(
    EPOCH_MS(? :: BIGINT), 
    TO_WEEKS(
      DATE_DIFF(
        'week', 
        EPOCH_MS(? :: BIGINT), 
        dataEv
      )
    )
  )
ORDER BY 
  week`;

export const TECHNOLOGY_GROUP_ANIMAL_GRID = `
SELECT 
	AnmID,
	EPOCH_MS(FIRST(dataEv) FILTER(WHERE key = 'boar')::BIGINT) as inseminationDate,
	FIRST(cycle)::INTEGER as cycle,
	COALESCE(LIST({date: epoch_ms(dataEv::BIGINT), result: TRY_CAST(value AS INTEGER)}) FILTER(WHERE key = 'usgResult'), []) as usg,
	FIRST(value) FILTER(WHERE key = 'expectedFarrowing') as expectedFarrowing,
	FIRST({date: epoch_ms(dataEv::BIGINT), diff: TRY_CAST(value AS INTEGER)}) FILTER(WHERE key = 'shiftFarrowDay') as farrowing,
	FIRST({date: epoch_ms(dataEv::BIGINT), amount: TRY_CAST(value AS INTEGER)}) FILTER(WHERE key = 'weanedPiglet') as separation,
    FIRST({reason: value}) FILTER(WHERE key = 'technologyGroupRemoval') as removed,
    FIRST(value) FILTER(WHERE key = 'isMommy')::BOOLEAN as isMommy,
    COALESCE(LIST({date: epoch_ms(dataEv::BIGINT), medicine: value}) FILTER(WHERE key = 'vaccination'), []) as vaccinations,
    COALESCE(LIST({date: epoch_ms(dataEv::BIGINT), medicine: value}) FILTER(WHERE key = 'pigletVaccination'), []) as pigletVaccinations
FROM (SELECT * FROM ParamsTable WHERE group_nr = ? ORDER BY dataEv) WHERE AnmID IS NOT NULL GROUP BY AnmID -- AnmID IS NOT NULL musi być, ponieważ pigletRoomSeparation nie ma AnmID i psuje rekordy
`;

export const TECHNOLOGY_GROUPS_ANIMALS = `
SELECT 
  group_nr, 
  LIST(DISTINCT AnmID) as animals 
FROM 
  (
    SELECT 
      AnmID, 
      group_nr, 
      FIRST(value) FILTER (WHERE key = 'technologyGroupRemoval') as removeReason 
    FROM 
      ParamsTable 
    WHERE 
      (
        key = 'boar' 
        OR key = 'technologyGroupRemoval'
      )
      AND group_nr IN ?
    GROUP BY 
      AnmID, 
      group_nr
  ) 
WHERE 
  removeReason IS NULL 
  OR removeReason IN (${REMOVE_TECHNOLOGY_GROUP_REASONS.SEPARATION}::VARCHAR, ${REMOVE_TECHNOLOGY_GROUP_REASONS.REMOVED_ALL_PIGLETS}::VARCHAR) 
GROUP BY 
  group_nr
`;

const TECHNOLOGY_GROUP_STATS = `
SELECT 
  group_nr, 
  COUNT(
    DISTINCT CASE WHEN key = 'boar' THEN AnmID END
  ) as sowCountStart, 
  COUNT(
    DISTINCT CASE WHEN key = 'technologyGroupRemoval' THEN AnmID END
  ) as sowCountRemoved 
FROM 
  ParamsTable 
WHERE 
  key IN(
    'boar', 'technologyGroupRemoval'
  ) 
  AND group_nr IN @(?) 
GROUP BY 
  group_nr`;

export const TECHNOLOGY_GROUP_TASKS = {
    MATING: "mating",
    USG: "USG",
    TRANSFER_SOWS: "transferToSows",
    TRANSFER_DELIVERY: "transferToDelivery",
    PARTURITION: "parturition",
    SEPARATION: "separation",
    GRAFTING: "grafting",
};

export function getCreateDay() {
    try {
        let state = store.getState();
        return state.technologyGroup.createDay[0].createDay;
    } catch (e) {
        return 0;
    }
}

export function isRemovedFromTechnologyGroup(
    insemination,
    events,
    animal,
    cycleTable = null,
    {weeks, start, method, years} = {} // wartości z selektora getTechnologyGroupSettings
) {
    const inseminationDate = moment.utc(insemination.EvTime);
    const {end} = getTechnologyGroupByTime(
        +inseminationDate,
        start,
        weeks,
        method,
        years
    );
    const max = +end;
    // const { max } = getTechnologyGroupByWeek(inseminationDate.isoWeek(), inseminationDate.year(), {
    //     technologyGroupWeeks,
    //     technologyGroupStart
    // });
    // let otherAnimalEvents = events.filter(item => item.AnmID === insemination.AnmID && !item.DtaDelTime && moment.utc(item.EvTime).isBetween(insemination.EvTime, new Date(), "[]"));
    let otherAnimalEvents = events.filter(
        (item) => item.AnmID === insemination.AnmID && !item.DtaDelTime
    );
    let cycles = cycleTable
        ? {cycleTable: cycleTable.slice()}
        : preEvents(otherAnimalEvents, animal);
    let cycle = null;
    for (let c of cycles.cycleTable) {
        if (
            c[EventTypes.INSEMINATION].find(
                (item) => item.EvID === insemination.EvID
            )
        ) {
            cycle = c;
            break;
        }
    }
    if (cycle[EventTypes.IS_MOMMY].length > 0) {
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.IS_MOMMY,
            event: cycle[EventTypes.IS_MOMMY][0],
        };
    }
    // sprawdzanie czy bylo odsadzenie prosiat, poniewaz odsadzenie zostawia w grupie
    let separation = cycle[EventTypes.SEPARATION][0];
    if (separation) return null;
    // sprawdzanie czy miala negatywne badanie usg po inseminacji
    let usg = cycle[EventTypes.USG].find(
        (item) => item.EvData.Pregnant === USG_STATE.NEGATIVE
    );
    if (usg)
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.NEGATIVE_USG,
            event: usg,
        };
    // sprawdzanie czy byl zlogoszony brak ciazy
    let noPregnancy = cycle[EventTypes.NO_PREGNANCY][0];
    if (noPregnancy)
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.NO_PREGNANCY,
            event: noPregnancy,
        };
    // sprawdzanie czy byla inseminacja w kolejny tygodniu
    otherAnimalEvents = otherAnimalEvents.filter((item) =>
        moment.utc(item.EvTime).isBetween(insemination.EvTime, new Date(), "[]")
    );
    let otherInsemination = otherAnimalEvents.find(
        (item) =>
            item.EvCode === EventTypes.INSEMINATION &&
            moment.utc(item.EvTime).isAfter(max, "day") &&
            !cycle[EventTypes.INSEMINATION].find(
                (cycleInsemination) => item.EvID === cycleInsemination.EvID
            )
    );
    if (otherInsemination)
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.INSEMINATION_OTHER_WEEK,
            event: otherInsemination,
        };
    // sprawdzanie czy zwierze upadlo
    let fall = otherAnimalEvents.find(
        (item) => item.EvCode === EventTypes.FALL
    );
    if (fall)
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.FALL,
            event: fall,
        };
    //sprawdzanie czy zwierze zostalo sprzedane
    let sell = otherAnimalEvents.find(
        (item) => item.EvCode === EventTypes.SELL
    );
    if (sell)
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.SELL,
            event: sell,
        };
    if (cycles.cycleTable.find((item) => item.cycle > cycle.cycle)) {
        return {
            reason: REMOVE_TECHNOLOGY_GROUP_REASONS.NEXT_CYCLE,
        };
    }
    return null;
}

export function isCurrentTechnologyGroup(max) {
    return moment.utc().diff(max, "weeks") < 20;
}

export function getTasksForGroup(startOfGroup, endOfGroup, graftingProgram) {
    let timeOnMating = Math.ceil(getTimeOnMatingRoom() / 7);
    let timeOnSows = Math.ceil(getTimeOnSowsRoom() / 7);
    let timeFromInseminationToPregnancy = Math.floor(
        getTimeFromInseminationToPregnancy() / 7
    );
    let timeFromInseminationToParturition = Math.floor(
        getTimeFromInseminationToPartuition() / 7
    );
    let groupIndex = moment.utc().startOf("day").diff(startOfGroup, "weeks");
    let tasks = [];
    if (groupIndex >= timeFromInseminationToParturition)
        tasks.push({
            task: TECHNOLOGY_GROUP_TASKS.PARTURITION,
            start: +moment(startOfGroup).add(
                timeFromInseminationToParturition,
                "weeks"
            ),
            end: +moment(endOfGroup).add(
                timeFromInseminationToParturition,
                "weeks"
            ),
        });
    if (groupIndex >= timeFromInseminationToPregnancy)
        tasks.push({
            task: TECHNOLOGY_GROUP_TASKS.USG,
            start: +moment(startOfGroup).add(
                timeFromInseminationToPregnancy,
                "weeks"
            ),
            end: +moment(endOfGroup).add(
                timeFromInseminationToPregnancy,
                "weeks"
            ),
        });
    if (groupIndex >= 0)
        tasks.push({
            task: TECHNOLOGY_GROUP_TASKS.MATING,
            start: startOfGroup,
            end: endOfGroup,
        });
    if (groupIndex >= timeOnMating + timeOnSows - 1)
        tasks.push({
            task: TECHNOLOGY_GROUP_TASKS.TRANSFER_DELIVERY,
            start: +moment(startOfGroup).add(
                timeOnMating + timeOnSows - 1,
                "weeks"
            ),
            end: +moment(endOfGroup).add(
                timeOnMating + timeOnSows - 1,
                "weeks"
            ),
        });
    if (
        groupIndex >= timeOnMating - 1 &&
        !tasks.includes(TECHNOLOGY_GROUP_TASKS.TRANSFER_DELIVERY)
    )
        tasks.push({
            task: TECHNOLOGY_GROUP_TASKS.TRANSFER_SOWS,
            start: +moment(startOfGroup).add(timeOnMating - 1, "weeks"),
            end: +moment(endOfGroup).add(timeOnMating - 1, "weeks"),
        });
    if (groupIndex >= 20) tasks.push({task: TECHNOLOGY_GROUP_TASKS.SEPARATION});
    if (graftingProgram) {
        for (let row of graftingProgram.WData.MedicineList) {
            let age = null;
            if (
                row.Application === GraftingProgramApplicationTypes.INSEMINATION
            ) {
                age = Math.floor(row.Age / 7);
            }
            if (
                row.Application === GraftingProgramApplicationTypes.PARTURITION
            ) {
                age = Math.floor(
                    row.Age / 7 + timeFromInseminationToParturition
                );
            }
            if (
                row.Application === GraftingProgramApplicationTypes.SEPARATION
            ) {
                age = Math.floor(row.Age / 7 + 20);
            }
            if (age !== null && groupIndex >= age) {
                tasks.push({
                    task: row.Medicine,
                    start: moment(startOfGroup).add(age, "weeks"),
                    end: moment(endOfGroup).add(age, "weeks"),
                });
            }
        }
    }
    return tasks;
}

export function getTaskTranslation(task, medicines) {
    switch (task) {
        case TECHNOLOGY_GROUP_TASKS.PARTURITION:
            return i18n.t("apiNotifications.createParturitionTitle");
        case TECHNOLOGY_GROUP_TASKS.USG:
            return i18n.t("eventTypes.U");
        case TECHNOLOGY_GROUP_TASKS.MATING:
            return i18n.t("animalDocuments.insemination");
        case TECHNOLOGY_GROUP_TASKS.SEPARATION:
            return i18n.t("logsView.shortNames.1018");
        case TECHNOLOGY_GROUP_TASKS.TRANSFER_SOWS:
            return i18n.t("transferToSows");
        case TECHNOLOGY_GROUP_TASKS.TRANSFER_DELIVERY:
            return i18n.t("transferToDelivery");
        case TECHNOLOGY_GROUP_TASKS.GRAFTING:
            return i18n.t("eventTypes.G");
        default:
            let medicine = medicines.find((item) => item.WordID === task);
            if (medicine) {
                return medicine.WData.Name;
            }
    }
}

/**
 * Returns formatted name for technology group date range
 * @param {Object} groupObj - Object containing group properties
 * @param {Moment} groupObj.start - Start date of the technology group
 * @param {Moment} groupObj.end - End date of the technology group
 * @param {string} groupObj.displayName - Optional display name override
 * @param {boolean} forceShowYear - Force showing year in the name
 * @returns {string} Formatted technology group name
 */
export const formatTechnoGroupName = (
    {start, end, displayName},
    forceShowYear = false
) => {
    if (displayName) {
        if (forceShowYear) return `${displayName} (${start.year()})`;
        return displayName;
    }
    const dayDiff = Math.abs(start.diff(end, "days"));
    const isOneWeekGroup = dayDiff <= 7;
    const week1 = start.isoWeek();
    // dodawany jeden dzien, aby przekrecic tydzien w przypadku startu w poniedzialek
    const endShortenBy1Week = end.clone().add(1, "day").subtract(1, "week");
    const week2 = endShortenBy1Week.isoWeek();
    const year1 = start.isoWeekYear();
    const year2 = endShortenBy1Week.isoWeekYear();
    const showYear = year1 !== year2 || forceShowYear;
    const showWeek = week1 !== week2;
    if (showYear) {
        return !isOneWeekGroup && showWeek
            ? `${week1}-${week2} (${year2})`
            : `${week1} (${year1})`;
    }
    return !isOneWeekGroup && showWeek ? `${week1}-${week2}` : `${week1}`;
};

/**
 * Generates unique ID for technology group used for grid animations
 * Previously used week number but that's not unique in some cases
 * (one year can have two 52nd weeks; first days of new year have such cases)
 * @param {Moment} start - Start date of the technology group
 * @param {Moment} end - End date of the technology group
 * @returns {string} Unique ID in format "week-year.week-year"
 */
export const getTechnologyGroupDurationId = (start, end) => {
    return `${start.isoWeek()}-${start.isoWeekYear()}.${end.isoWeek()}-${end.isoWeekYear()}`;
};

const helpers = {
    /**
     * Returns technology group start day for given date
     * @param {number} time - Timestamp to calculate from
     * @param {number} technoGroupStartTime - Technology group start timestamp
     * @param {number} technoGroupDuration - Technology group duration in weeks
     * @returns {moment.Moment} Start date of technology group
     */
    getTechnoGroupStartByTime: (
        time,
        technoGroupStartTime,
        technoGroupDuration
    ) => {
        const day = moment.utc(time).startOf("day");
        const diffBetweenGroupStartAndStartOfYear = moment
            .utc(technoGroupStartTime)
            .diff(day, "week");
        // musimy zapamiętać znak działania przed wyrównaniem tygodnia
        const sign = diffBetweenGroupStartAndStartOfYear < 0 ? -1 : 1;
        // wyrównaj do pełnych tygodn rożnice tygodniu pomiędzy startem grupy a wybranym rokiem
        const diff =
            Math.ceil(
                Math.abs(diffBetweenGroupStartAndStartOfYear) /
                    technoGroupDuration
            ) *
            sign *
            technoGroupDuration;
        // pierwsza grupa technologiczna dla podanego roku
        const startTime = moment
            .utc(technoGroupStartTime)
            .subtract(diff, "week");
        // sprawdź, czy nie przelecieliśmy za bardzo i napraw
        if (+startTime > time) startTime.subtract(technoGroupDuration, "week");
        return startTime;
    },
    /**
     * Creates technology group object with range, name and ID
     * @param {Moment} startTime - Start time of the group
     * @param {number} weeks - Duration in weeks
     * @returns {Object} Technology group object with start, end, name and id properties
     */
    createTechnoGroup: (startTime, weeks) => {
        const start = startTime.clone();
        const end = startTime
            .clone()
            .add(weeks, "week")
            .subtract(1, "day")
            .endOf("day");
        let obj = {
            start,
            end,
            id: getTechnologyGroupDurationId(start, end),
        };
        return {
            ...obj,
            name: formatTechnoGroupName(obj),
        };
    },
    /**
     * Creates a manual technology group object from group configuration
     * @param {Object} group - Group configuration object
     * @param {string} group.Start - Start date string
     * @param {string} group.End - End date string
     * @param {string} group.Name - Group name
     * @param {string} group.Color - Group color
     * @return {Object} Technology group object with start, end, name, displayName, color, and id
     */
    createManualTechnoGroup(group) {
        const start = moment.utc(group.Start);
        const end = moment.utc(group.End).endOf("day");
        return {
            start,
            end,
            name: group.Name,
            displayName: group.Name,
            color: group.Color,
            id: getTechnologyGroupDurationId(start, end),
        };
    },
    /**
     * Returns manually defined technology groups for given year
     * @param {Array} technoGroupInYears - Array of year configurations with groups
     * @param {number} year - Year to get groups for
     * @returns {Array} Array of technology group objects
     */
    getManualTechnoGroups: memoize(
        (technoGroupInYears, year) => {
            console.log("getManualTechnoGroups", technoGroupInYears, year);
            const yearGroups = technoGroupInYears.find(
                (item) => item.SetData.Year === year
            );
            if (!yearGroups) return [];
            return yearGroups.SetData.Groups.map((group) =>
                helpers.createManualTechnoGroup(group)
            );
        },
        (...args) => JSON.stringify(args)
    ),
    /**
     * Gets technology group for a specific time in manual mode
     * @param {number} time - Timestamp to check
     * @param {Array} technoGroupInYears - Array of years with manual technology groups
     * @return {Object|null} Technology group object or null if not found
     */
    getTechnologyGroupInTimeForManual: (time, technoGroupInYears) => {
        const day = moment.utc(time).startOf("day");
        const year = day.year();
        const possibleGroups = technoGroupInYears.filter(
            (item) => Math.abs(item.SetData.Year - year) <= 1 // sprawdzamy rok poprzedni, bieżący i następny
        );
        for (let groups of possibleGroups) {
            for (let group of groups.SetData.Groups) {
                const start = moment.utc(group.Start);
                const end = moment.utc(group.End).endOf("day");
                if (day.isBetween(start, end, null, "[]")) {
                    return helpers.createManualTechnoGroup(group);
                }
            }
        }
        return null;
    },
};

/**
 * Returns array of technology group objects with duration ranges for given year and settings
 * @param {number} technoGroupStartTime - Timestamp from which technology groups are calculated
 * @param {number} technoGroupDuration - Number indicating duration of individual technology groups
 * @param {number} year - Year for which to return technology groups list
 * @param {string} method - Technology group generation method
 * @param {Array} technoGroupInYears - Array of years data for manual method
 * @returns {Array} Array of objects with start and end Moment dates
 */
export const getTechnologyGroupWeeksByYear = memoize(
    (
        technoGroupStartTime,
        technoGroupDuration,
        year,
        method,
        technoGroupInYears
    ) => {
        if (method === "manual") {
            return helpers.getManualTechnoGroups(technoGroupInYears, year);
        }
        const startOfYear = moment.utc(year, "YYYY").startOf("year");
        const currentTechnoGroup = helpers.getTechnoGroupStartByTime(
            +startOfYear,
            technoGroupStartTime,
            technoGroupDuration
        );
        const weeks = [];
        if (currentTechnoGroup.isoWeekYear() < year)
            currentTechnoGroup.add(technoGroupDuration, "week");
        while (currentTechnoGroup.isoWeekYear() === year) {
            const start = currentTechnoGroup.clone();
            weeks.push(helpers.createTechnoGroup(start, technoGroupDuration));
            currentTechnoGroup.add(technoGroupDuration, "week");
        }
        return weeks;
    },
    (...args) => JSON.stringify(args)
);

/**
 * returns technology group by insemination time (or just time)
 * @param time {number}
 * @param technoGroupStartTime {number|null}
 * @param technoGroupDuration {number|null}
 * @param method {'manual'|'automatic'}
 * @param technoGroupInYears {Array<>} array of years in which technology groups start (only for manual method)
 * @return {{start: *, name: string, end: *, id: `${*}-${*}.${*}-${*}`}}
 */
export const getTechnologyGroupByTime = (
    time,
    technoGroupStartTime,
    technoGroupDuration,
    method,
    technoGroupInYears = []
) => {
    // if (isNil(technoGroupDuration))
    //     technoGroupDuration = getTechnologyGroupWeeks();
    // if (isNil(technoGroupStartTime))
    //     technoGroupStartTime = getFirstTechnologyGroupStart();
    // if (isNil(method)) {
    //     method = getTechnologyGroupGenerationMethod();
    // }
    const day = moment.utc(time).startOf("day");
    if (method === "manual") {
        return helpers.getTechnologyGroupInTimeForManual(
            +day,
            technoGroupInYears
        );
    }
    const start = helpers.getTechnoGroupStartByTime(
        +day,
        technoGroupStartTime,
        technoGroupDuration
    );
    return helpers.createTechnoGroup(start, technoGroupDuration);
};

export function getTechnologyGroupName(
    inseminationTime,
    {weeks, start, method, years} = {} // wartości z selektora getTechnologyGroupSettings
) {
    const technoGroup = getTechnologyGroupByTime(
        inseminationTime,
        start,
        weeks,
        method,
        years
    );
    if (!technoGroup) return "?";
    return technoGroup.name;
    // let technologyGroupStartDay = moment.utc(technologyGroupStart).isoWeekday();
    // if (technologyGroupWeeks === 1) {
    //     let inseminationWeekDay = moment.utc(inseminationTime).isoWeekday();
    //     if (
    //         technologyGroupStart !== 1 &&
    //         inseminationWeekDay < technologyGroupStartDay
    //     )
    //         return moment.utc(inseminationTime).subtract(1, "week").week();
    //     return moment.utc(inseminationTime).week();
    // }
    // let diff = moment.utc(inseminationTime).diff(technologyGroupStart, "weeks");
    // let groupsDiff = Math.floor(diff / technologyGroupWeeks);
    // let groupTime = moment
    //     .utc(technologyGroupStart)
    //     .add(groupsDiff * technologyGroupWeeks, "weeks");
    // let week = groupTime.week();
    // return `${week} - ${week + technologyGroupWeeks - 1}`;
}

/**
 * Retrieves the list of animals in a technology group for a given start time
 * @param {number} startTime - Start timestamp for the technology group
 * @param {Object} options - Technology group settings
 * @param {number} options.weeks - Number of weeks in technology group
 * @param {number} options.start - Technology group start time
 * @param {string} options.method - Technology group generation method
 * @param {Array} options.years - Array of years data for manual method
 * @param {Function} queryCaller - Database query function
 * @returns {Promise<Array>} Array of animal IDs in the technology group
 */
export async function getTechnologyGroupAnimals(
    startTime,
    {weeks, start, method, years}, // wartości z selektora getTechnologyGroupSettings
    queryCaller
) {
    try {
        const technoGroup = getTechnologyGroupByTime(
            startTime,
            start,
            weeks,
            method,
            years
        );
        if (!technoGroup) return [];
        const groupName = formatTechnoGroupName(technoGroup, true);
        const res = await queryCaller(ANIMALS_IN_GROUP, [groupName]);
        if (res.length === 0 || !res[0].AnmIDs) return [];
        return res[0].AnmIDs;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export async function getTechnologyGroupsForAnimals(AnmIDs, queryCaller) {
    const res = await queryCaller(GROUPS_FOR_ANIMALS, [AnmIDs]);
    return uniq(res.map((item) => item.group_nr));
}

/**
 * Gets technology group objects with detailed information for given animal IDs
 * @param {Array} AnmIDs - Array of animal IDs
 * @param {Function} queryCaller - Database query function
 * @param {Object} options - Technology group settings
 * @param {number} options.weeks - Number of weeks in technology group
 * @param {number} options.start - Technology group start time
 * @param {string} options.method - Technology group generation method
 * @param {Array} options.years - Array of years data for manual method
 * @returns {Promise<Array>} Array of objects with group name and value properties
 */
export async function getTechnologyGroupsObjectsForAnimals(
    AnmIDs,
    queryCaller,
    {weeks, start, method, years} // wartości z selektora getTechnologyGroupSettings
) {
    console.log(AnmIDs);
    const groups = await getTechnologyGroupsForAnimals(AnmIDs, queryCaller);
    const groupYears = {};
    const regex = new RegExp("\\d{4}");
    let values = [];
    for (let group of groups) {
        if (!group) continue;
        const year = group.match(regex)[0];
        if (!groupYears[year]) {
            let tmp = {};
            const groupsInYear = getTechnologyGroupWeeksByYear(
                start,
                weeks,
                +year,
                method,
                years
            );
            for (let row of groupsInYear) {
                const name = formatTechnoGroupName(row, true);
                tmp[name] = row;
            }
            groupYears[year] = tmp;
        }
        values.push({name: group, value: groupYears[year][group]});
    }
    return values;
}

/**
 * Gets the last N technology groups, optionally shifted by a number of weeks
 * @param {Object} options - Technology group settings
 * @param {number} options.weeks - Number of weeks in technology group
 * @param {number} options.start - Technology group start time
 * @param {string} options.method - Technology group generation method
 * @param {Array} options.years - Array of years data for manual method
 * @param {number} numberOfTechnologyGroups - Number of groups to retrieve
 * @param {number} [shift=0] - Number of weeks to shift back from current date
 * @returns {Array} Array of technology group objects
 */
export function getLastTechnologyGroups(
    {weeks, start, method, years}, // wartości z selektora getTechnologyGroupSettings
    numberOfTechnologyGroups,
    shift = 0
) {
    if (method === "manual") {
        const groups = [];
        const yearsCopy = [...years]
            .sort((a, b) => b.SetData.Year - a.SetData.Year)
            .filter((year) => moment.utc().year() >= year.SetData.Year);
        for (let yearData of yearsCopy) {
            for (let i = yearData.SetData.Groups.length - 1; i >= 0; i--) {
                const group = yearData.SetData.Groups[i];
                const start = moment.utc(group.Start);
                // only groups before current date minus shift
                if (start.isAfter(moment.utc().subtract(shift, "weeks")))
                    continue;
                groups.push(helpers.createManualTechnoGroup(group));
                if (groups.length === numberOfTechnologyGroups)
                    return groups.sort((a, b) => b.start - a.start);
            }
        }
        return groups.sort((a, b) => b.start - a.start);
    }
    const groupWeeks = getTechnologyGroupWeeksByYear(
        start,
        weeks,
        moment.utc().year(),
        method,
        years
    ).filter((item) =>
        item.start.isBefore(moment.utc().subtract(shift, "weeks"))
    );
    if (groupWeeks.length < numberOfTechnologyGroups) {
        const prevYearWeeks = getTechnologyGroupWeeksByYear(
            start,
            weeks,
            moment.utc().year() - 1,
            method,
            years
        );
        groupWeeks.unshift(
            ...prevYearWeeks.slice(
                prevYearWeeks.length -
                    numberOfTechnologyGroups +
                    groupWeeks.length
            )
        );
    }
    return groupWeeks;
}

/**
 * Generates a grid of technology groups for the last 21 weeks
 * @param {number} technoGroupStartTime - Start timestamp for technology groups
 * @param {number} technoGroupDuration - Duration of each technology group in weeks
 * @param {string} method - Technology group generation method
 * @param {Array} years - Array of years data for manual method
 * @returns {Array} Array of technology group grid objects with week, year, group info
 */
export function getTechnologyGroupGrid(
    technoGroupStartTime,
    technoGroupDuration,
    method,
    years
) {
    let tmp = [];
    const day = moment.utc(technoGroupStartTime).day();
    const start = moment.utc().day(day);
    if (start.isAfter(moment.utc(), "day")) {
        start.subtract(1, "week");
    }
    for (let i = 0; i < 21; i++) {
        const week = start.clone().subtract(i, "weeks");
        const group = getTechnologyGroupByTime(
            +week,
            technoGroupStartTime,
            technoGroupDuration,
            method,
            years
        );
        tmp.push({
            week: week.isoWeek(),
            year: week.year(),
            group,
            start: +week.startOf("day"),
            end: +week.clone().add(6, "days").endOf("day"),
        });
    }
    return tmp;
}

export async function getTechnologyGroupGridData(
    weeks,
    technoGroupStartTime,
    queryCaller
) {
    try {
        const groups = [];
        for (let week of weeks) {
            if (week.group) {
                groups.push(formatTechnoGroupName(week.group, true));
            }
        }
        if (groups.length === 0) return [];
        const firstCycleIndex = getFirstCycleIndex();
        const res = await queryCaller(TECHNOLOGY_GROUP_GRID, [
            groups,
            groups,
            technoGroupStartTime,
            technoGroupStartTime,
            firstCycleIndex,
            firstCycleIndex,
            firstCycleIndex,
            firstCycleIndex,
            technoGroupStartTime,
            technoGroupStartTime,
        ]);
        let tmp = {};
        for (let row of res) {
            tmp[+new Date(row.week)] = row;
        }
        return tmp;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export function getTechnologyGroupAnimalData(group, queryCaller) {
    const res = queryCaller(TECHNOLOGY_GROUP_ANIMAL_GRID, [group]);
    return res;
}

export async function getTechnologyGroupsAnimals(groups, queryCaller) {
    const res = await queryCaller(TECHNOLOGY_GROUPS_ANIMALS, [groups]);
    return createKeyToValueDictionary(res, "group_nr");
}

/**
 * Gets the names of the last N technology groups with an optional offset
 * @param {number} amount - Number of technology group names to retrieve
 * @param {number} offset - Number of weeks to offset from current date
 * @param {Object} options - Technology group settings
 * @param {number} options.weeks - Number of weeks in technology group
 * @param {number} options.start - Technology group start time
 * @param {string} options.method - Technology group generation method
 * @param {Array} options.years - Array of years data for manual method
 * @returns {Array<string>} Array of technology group names
 */
export function getLastTechnologyGroupNames(
    amount,
    offset,
    {weeks, start, method, years} = {} // wartości z selektora getTechnologyGroupSettings
) {
    const names = [];
    for (let i = 0; i < amount; i++) {
        const technologyGroup = getTechnologyGroupByTime(
            moment.utc().subtract(offset + i * weeks, "weeks"),
            start,
            weeks,
            method,
            years
        );
        if (technologyGroup) {
            const name = formatTechnoGroupName(technologyGroup, true);
            names.push(name);
        }
    }
    return names;
}

export const TECHNOLOGY_GROUP_TASK_NAMES = {
    INSEMINATION: "Insemination",
    USG: "USG",
    PARTURITION: "Parturition",
    SEPARATION: "Separation",
    VACCINATION: "Vaccination",
    PIGLETS_VACCINATION: "PigletsVaccination",
    TRANSFER: "Transfer",
    PIGLETS_CASTRATION: "PigletsCastration",
    PIGLETS_TEETH: "PigletsTeeth",
    PIGLETS_TAILS: "PigletsTails",
    PIGLETS_WEIGHTING: "PigletsWeighting",
    MANUAL: "Manual",
};

export function technologyGroupTaskTranslation(name) {
    switch (name) {
        case TECHNOLOGY_GROUP_TASK_NAMES.PIGLETS_WEIGHTING:
            return i18n.t("pigletsWeighting");
        case TECHNOLOGY_GROUP_TASK_NAMES.USG:
            return i18n.t("usg");
        default:
            return i18n.t(lowerFirst(name));
    }
}

// export function getTechnologyGroupStartByName(
//     name,
//     {technoGroupStartTime} = {}
// ) {
//     const split = name.split(" ");
//     let startingWeek = split[0];
//     const year = split[1].slice(1, -1);
//     if (startingWeek.includes("-")) startingWeek = startingWeek.split("-")[0];
//     if (isNil(technoGroupStartTime))
//         technoGroupStartTime = getFirstTechnologyGroupStart();
//     const startTime = moment.utc(technoGroupStartTime);
//     console.log(moment.utc().isoWeekYear(+startingWeek));
//     return +moment
//         .utc()
//         .isoWeekYear(+year)
//         .isoWeek(+startingWeek)
//         .day(startTime.day())
//         .startOf("day");
// }

export async function getTechnologyGroupStats(groups, queryCaller) {
    console.error(groups);
    const res = await queryCaller(TECHNOLOGY_GROUP_STATS, [groups]);
    return createKeyToValueDictionary(res, "group_nr");
}

/**
 * Gets all years that have technology groups based on the method and start date
 * @param {number} technoGroupStart - Start timestamp for technology groups
 * @param {string} method - Technology group generation method ('manual' or 'automatic')
 * @param {Array} years - Array of years data for manual method
 * @returns {Array<number>} Array of year numbers
 */
export function getYearsWithTechnologyGroups(technoGroupStart, method, years) {
    if (method === "manual") {
        return years.map((item) => item.SetData.Year);
    }
    const tmp = [];
    const startingYear = moment.utc(technoGroupStart).year();
    for (let i = startingYear; i <= moment.utc().year(); i++) {
        tmp.push(i);
    }
    return tmp;
}
